module.exports = __webpack_public_path__ + "img/1542423391.f9271bc2.jpg";